import classNames from 'classnames'

import SelectorItem from './SelectorItem/SelectorItem'
import SVGIcon from './Icons/svgs/SVGIcon'
import CheckmarkCircleIcon from './Icons/svgs/CheckmarkCircleIcon'
import CircleOutlineThinIcon from './Icons/svgs/CircleOutlineThinIcon'

interface Items<T extends string> {
  value: T
  label?: string
}

export default function MultiSelect<T extends string>({
  display,
  displayCheckmarkIcon = true,
  gridClassNames,
  handleOnClick,
  items,
  state,
}: {
  display?: 'grid'
  displayCheckmarkIcon?: boolean
  gridClassNames?: string
  handleOnClick: (item: T) => void
  items: Array<Items<T>>
  state: T[]
}): React.ReactElement {
  return (
    <div className={display === 'grid' ? `grid ${gridClassNames}` : 'flex flex-wrap'}>
      {items.map(({ value, label }) => {
        return (
          <MultiSelectItem
            display={display}
            displayCheckmarkIcon={displayCheckmarkIcon}
            isSelected={state.includes(value)}
            item={value}
            key={value}
            label={label ?? value}
            onClick={handleOnClick}
          />
        )
      })}
    </div>
  )
}

function MultiSelectItem<T>({
  display,
  displayCheckmarkIcon,
  isSelected,
  item,
  label,
  onClick,
}: {
  display?: 'grid'
  displayCheckmarkIcon: boolean
  isSelected: boolean
  item: T
  label: string
  onClick: (item: T) => void
}): React.ReactElement {
  const cx = classNames(
    '!p-2',
    '!w-auto',
    'flex',
    'items-center',
    'justify-center',
    'space-x-1',
    display === 'grid' ? 'm-0' : 'mr-2 mb-2',
  )

  return (
    <SelectorItem className={cx} isSelected={isSelected} onClick={() => onClick(item)} type="button">
      {displayCheckmarkIcon && (
        <SVGIcon
          icon={isSelected ? CheckmarkCircleIcon : CircleOutlineThinIcon}
          pathClassName="currentColor"
          size={16}
        />
      )}
      <span>{label}</span>
    </SelectorItem>
  )
}
